/* ============
 * All Product Deposits
 * ============
 *
 * All product deposits.
 */

import Vue from 'vue';
import store from './../../store';
import productDepositTransformer from './../../transformers/productDeposit';

const success = ({ data }, resolve) => {
  const productDeposits = productDepositTransformer.fetchCollection(data.data);

  store.dispatch('fetchAllProductDeposits', { productDeposits });
  store.dispatch('setNullDeposit');
  resolve();
};

const failed = () => {
};

// Display the product deposits.
export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('product_deposits')
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/productDeposit/all.js